export const CAPABILITY_NAME_CUSTOM = 'custom';
export const CUSTOM_PREFIX = 'custom_';

export const CUSTOM_ENROLL_INFORMATION = 'custom_enroll_information';
export const CUSTOM_SUBSCRIPTION = 'custom_subscription';

export const DETAILS_SOURCE_INTEGRATION = 'integration';
